export default __webpack_public_path__ + "static/media/MotherNeeds.cbda5046.svg";